module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/112-laos-bda5d6734cee36895a982bc97b74ca00.svg";